const properties = {
  'orgAdminLogic': {
    'all': {
      'roles': {
        'any': [
          'Application Admin',
          'Security Administrator',
          'Exchange Operator'
        ]
      }
    }
  },
  'grantAppToUserLogic': {
    'all': {
      'roles': {
        'any': [
          'Application Admin',
          'Security Administrator',
          'Exchange Operator',
          'Maintenance User',
          'Materials Manager'
        ]
      },
      'entitlements': {
        'any': [
          'Full Tree Access',
          'Approve/Grant User Service Request',
          'Security Admin - Grant User Package',
          'SO Grant User Package'
        ]
      }
    }
  },
  'grantAppToOrgLogic': {
    'all': {
      'roles': {
        'any': [
          'Application Admin',
          'Security Administrator',
          'Exchange Operator',
          'Maintenance User',
          'Materials Manager'
        ]
      },
      'entitlements': {
        'any': [
          'Full Tree Access',
          'Grant Organization Service Request',
          'Security Admin - Grant Division Package'
        ]
      }
    }
  },
  'accessByAnyAdmin': {
    'all': {
      'roles': {
        'any': [
          'Application Admin',
          'Security Administrator',
          'Individual Service Admin - Owning Org',
          'TIB Administrator',
          'Organization Service Admin',
          'Organization Password Administrator',
          'Federation Configuration Admin',
          'Provider Administrator',
          'Exchange Operator',
          'Help Desk Plus',
          'Service Administrator',
          'Help Desk Basic',
          'User Account Administrator'
        ]
      }
    }
  },
  'globalSearch': {
    'all': {
      'roles': {
        'any': [
          'Application Admin',
          'Security Administrator',
          'Exchange Operator'
        ]
      }
    }
  },
  'accessToSecurityAndExchangeAdmins': {
    'all': {
      'roles': {
        'any': [
          'Security Administrator',
          'Exchange Operator'
        ]
      }
    }
  }
}
export default {
  properties
}



//////////////////
// WEBPACK FOOTER
// ./static/properties/appConfig.js
// module id = null
// module chunks = 